import classes from "../ServicesTable.module.scss"
import { forwardRef, Fragment, useContext, useEffect, useImperativeHandle, useLayoutEffect, useRef, useState } from "react";
import { Container, Row , Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useForm, Controller  } from "react-hook-form";
import { TextField } from "../../integrationWizard/form/TextField";
import VisibilityIcon from '@mui/icons-material/Visibility';
import Button from "../../UI/Button";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import OutboxIcon from '@mui/icons-material/Outbox';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import LoginIcon from '@mui/icons-material/Login';
import StartIcon from '@mui/icons-material/Start';
import PublicIcon from '@mui/icons-material/Public';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CertificateField from "../CertificateField";
import { OrgIdContext } from "../../../store/orgId_context";
import { DDD, E2Data } from "../../../lib/ddd/ddd";
import { GenericTooltip } from "../../integrationWizard/form/GenericTooltip";
import {stringExpressionReplacement} from "../../../lib/ddd/helpers"
import { NotificationManager} from 'react-notifications';
import { Button as MButton, Dialog, DialogActions, DialogContent, DialogTitle,FormControl, FormControlLabel, InputLabel, MenuItem, Select, Switch } from "@mui/material";
import { useTranslation } from "react-i18next";
import CertificateInput from "../servicesTable/CertificateInput";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import PaymentsIcon from '@mui/icons-material/Payments';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import HelpIcon from '@mui/icons-material/Help';
import { default as ReactSelect } from 'react-select';
import CustomSelect from "./CustomSelect";
import TextInputWithDropdown from "./TextInputWithDropdown";
import { useQuery } from "@tanstack/react-query";
import WorkflowTextInput from "./WorkflowTextInput";
import FiscUnitDropdown from "./FiscUnitDropdown";
import FiscOperatorDropdown from "./FiscOperatorDropdown";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new E2Data("EU_AOrg_ServicesEndpoints");
const dddevice = new E2Data("VP_DevicesOrgUnits");
dddevice.format = "full";
const _ddd = new DDD(apiRequestAddress);

const e2stepData = new E2Data("EU_AOrg_ServicesEndpoints");
e2stepData.format = "full";
e2stepData.filter = "ServiceEndPointCode__Step = '40'";

const FiscalizationForm = forwardRef(({deviceId, refetch, orgData, reloadDataForce}, ref) => {
    const [device, setDevice] = useState(undefined);
    const [data, setData] = useState();
    const [instructions, setInstructions] = useState(null);
    const { isMaintainer, sessionInfo } = useContext(OrgIdContext);
    const unitRef = useRef();
    const deviceRef = useRef();
    const operatorRef = useRef();
    const {t} = useTranslation();

    const {isPending:stepPending, data:stepData} = useQuery({
        queryKey: ['Data.GetEntityData', e2stepData.GetParamsObject()],
        queryFn: () => e2stepData.GetData()
    })
//#region field helpers

    useEffect(() => {
        if(device === deviceId) return;
        setDevice(deviceId)
        reloadDeviceData(deviceId);
    }, [deviceId, device]);

    useEffect(() => {
        if(!device) return;
        reloadDeviceData(device);
    }, [refetch]);

    useEffect(() => {
        if(instructions || !stepData) return;
        //console.log(stepData?.result?.data?.[0]?.ServiceEndPointCode__AdditionalUIRules) 
        let srvInstructions = stepData?.result?.data?.[0]?.ServiceEndPointCode__AdditionalUIRules;
        if(!srvInstructions) setInstructions(defaultForm);

        /* console.log(stepData);
        console.log(srvInstructions); */
        try{
            srvInstructions = JSON.parse(srvInstructions);
            //console.log(srvInstructions);
            setInstructions(srvInstructions);
        }catch(e){
            console.error("Error parsing instructions");
            setInstructions(defaultForm);
        }
        //console.log(stepData);
    }, [stepData]);

    const reloadDeviceData = (id) =>{
        dddevice.filter = `Id="${id}"`;
        dddevice.GetData().then(res => {
            setData(res?.result?.data?.[0])
        });
    }

    const onBeforeSave = async (newData) => {
        let errors = [];
        let res;
        res = await deviceRef?.current?.onBeforeSave(newData);
        if(hasErrors(res)) errors.push(hasErrors(res));
        res = await unitRef?.current?.onBeforeSave(newData);
        if(hasErrors(res)) errors.push(hasErrors(res));
        res = await operatorRef?.current?.onBeforeSave(newData);
        if(hasErrors(res)) errors.push(hasErrors(res));

        if(errors.length > 0) return errors;
        return true;
    }
    const onAfterSave = async (newData) => {
        let res = null;
        let errors = [];
        res = await deviceRef?.current?.onAfterSave(newData);
        console.log(res);
        if(hasErrors(res)) errors.push(hasErrors(res));
        res = await unitRef?.current?.onAfterSave(newData);
        if(hasErrors(res)) errors.push(hasErrors(res));
        res = await operatorRef?.current?.onAfterSave(newData);
        if(hasErrors(res)) errors.push(hasErrors(res));
        if(errors.length > 0) return errors;
        return true;
    }

    const hasErrors = (res) => {
        if(!Array.isArray(res)) return false;
        return res?.find(e => e?.error);
    };

    const _forceReloadData = () => {
        if(reloadDataForce) reloadDataForce();
        reloadDeviceData(device);
    }

    useImperativeHandle(ref, () => ({
        onBeforeSave,
        onAfterSave
    }), [deviceId, refetch, orgData, data, stepData]);

    return (
        <>
        <div className={`d-flex classes["formContainer2"]`} style={{padding:"0px", gap: "1rem"}}>
            {/* <TextInputWithDropdown  deviceData={data} orgData={orgData?.result?.data?.[0]} stepData={stepData?.result?.data?.[0]}/>   */}
            {/* <WorkflowTextInput ref={temp} deviceData={data} orgData={orgData} stepData={stepData?.result?.data?.[0]} fieldName="InternalName" instructions={bb}/>
            <WorkflowTextInput ref={temp} deviceData={data} orgData={orgData} stepData={stepData?.result?.data?.[0]} fieldName="InternalName" instructions={cc}/>  
            <WorkflowTextInput ref={temp} deviceData={data} orgData={orgData} stepData={stepData?.result?.data?.[0]} fieldName="InternalName" instructions={zz}/>  
            <WorkflowTextInput ref={temp} deviceData={data} orgData={orgData} stepData={stepData?.result?.data?.[0]} fieldName="InternalName" instructions={yy}/>  */} 
            {instructions && <>
                {instructions.FiscUnitRegCodeDef && <FiscUnitDropdown ref={unitRef} deviceData={data} orgData={orgData} stepData={stepData?.result?.data?.[0]} instructions={instructions.FiscUnitRegCodeDef}/>}
                {instructions.FiscOperatorRegCodeDef && <FiscOperatorDropdown ref={operatorRef} deviceData={data} orgData={orgData} stepData={stepData?.result?.data?.[0]} instructions={instructions.FiscOperatorRegCodeDef}/>}
                {instructions.FiscDeviceRegCode && <WorkflowTextInput ref={deviceRef} deviceData={data} orgData={orgData} stepData={stepData?.result?.data?.[0]} fieldName="FiscDeviceRegCode" instructions={instructions.FiscDeviceRegCode} reloadDataForce={_forceReloadData}/>}
            </>}
        </div>
        </>
    )
})

export default FiscalizationForm;


const FiscDeviceRegCode ={
    "required": false,
    "label" : "Device registration code",
    "editable": true,
    "instructions": null,
    "instructionsText": "For each cash register/device, it is necessary to input/assign a unique code at the level of the taxpayer.",
    "workflows" : [{"execute" : {"method" : "Data.Modify", "params" : {"entity" : "VP_DevicesOrgUnits", "filter":"Id='<!--device.Id-->'", "values" : {"FiscDeviceRegCode" : "<!--value-->"}}}}],
}
const FiscOperatorRegCodeDef ={
    "required": false,
    "label" : "Device operator code",
    "editable": true,
    "instructions": null,
    "instructionsText": "For the purposes of fiscalization, the tax identification number of the primary operator is entered. If the operator changes from one receipt to another, it should be provided in the input object of the receipt.",
    "workflows" : [{"execute" : {"method" : "Data.Modify", "params" : {"entity" : "VP_DevicesOrgUnits", "filter":"Id='<!--device.Id-->'", "values" : {"FiscOperatorRegCodeDef" : "<!--value-->"}}}}],
}
const FiscUnitRegCodeDef ={
    "required": false,
    "label" : "Unit registration code",
    "editable": true,
    "instructions": null,
    "instructionsText": "The designation of the business premises where the taxpayer issues invoices for cash transactions.",
    "workflows" : [{"execute" : {"method" : "Data.Modify", "params" : {"entity" : "VP_DevicesOrgUnits", "filter":"Id='<!--device.Id-->'", "values" : {"FiscUnitRegCodeDef" : "<!--value-->"}}}}],
}
//FiscUnitRegCodeDef
const FiscUnitRegCodeDefSlo = {
    "required": false,
    "label" : "Unit registration code",
    "editable": true,
    "instructions": "https://miniblagajna.fu.gov.si",
    "instructionsText": "Vpiše se oznaka poslovnega prostora, v katerem zavezanec izdaja račune pri gotovinskem poslovanju in je bila predhodno registrirana na davčnem portalu za potrebe fiskalizacije. Več na https://www.fu.gov.si/fileadmin/Internet/Nadzor/Podrocja/Davcne_blagajne_in_VKR/Opis/Davcne_blagajne_in_davcno_potrjevanje_racunov.docx",
    "workflows" : [{"execute" : {"method" : "Data.Modify", "params" : {"entity" : "VP_DevicesOrgUnits", "filter":"Id='<!--device.Id-->'", "values" : {"FiscUnitRegCodeDef" : "<!--value-->", "OrgUnitId":null}}}}],
    "OrgUnitId" : {
        "createWorkflows" : [
            {
                "type" : "table",
                "name" : "wf1",
                "fields" : {
                        "FiscUnitRegCode": {
                                "required": true,
                                "editable": true,
                                "title": "Oznaka poslovnega prostora",
                                "tooltip": "Vpiše se oznaka poslovnega prostora, v katerem zavezanec izdaja račune pri gotovinskem poslovanju.Oznaka je lahko sestavljena iz številk in črk 0-9, a-z, A-Z.Oznaka mora biti enaka kot tista, ki je navedena na računih. Oznaka je enkratna na nivoju zavezanca.",
                                "minlength": 1,
                                "maxlength": 20,
                                "example": "LK1",
                                "init": null
                            },
                        "NameUnit": {
                                "required": true,
                                "editable": true,
                                "title": "Name",
                                "tooltip": "Vpiše se oznaka poslovnega prostora, v katerem zavezanec izdaja račune pri gotovinskem poslovanju.Oznaka je lahko sestavljena iz številk in črk 0-9, a-z, A-Z.Oznaka mora biti enaka kot tista, ki je navedena na računih. Oznaka je enkratna na nivoju zavezanca.",
                                "minlength": 1,
                                "maxlength": 20,
                                "example": "LK1",
                                "init": null
                            },
                            "BPImmovable": {
                                "required": false,
                                "editable": true,
                                "title": "Tip prostora",
                                "tooltip": "True, če zavezanec izdaja račune v premičnem poslovnem prostoru.",
                                "minlength": 1,
                                "maxlength": 1,
                                "example": true,
                                "init": null
                            },
                            "BPImCadastralNum": {
                                "required": false,
                                "editable": true,
                                "title": "Številka katastrske občine",
                                "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                                "minlength": 0,
                                "maxlength": 4,
                                "example": "1200",
                                "init": null
                            },
                            "BPImBuildNum": {
                                "required": false,
                                "editable": true,
                                "title": "Številka stavbe",
                                "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                                "minlength": 0,
                                "maxlength": 5,
                                "example": 12,
                                "init": null
                            },
                            "BPImBuildSecNum": {
                                "required": false,
                                "editable": true,
                                "title": "Številka dela stavbe",
                                "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                                "minlength": 0,
                                "maxlength": 4,
                                "example": 3,
                                "init": null
                            },
    
                            "AddressUnit": {
                                "required": false,
                                "editable": true,
                                "title": "Ulica",
                                "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                                "minlength": 1,
                                "maxlength": 100,
                                "example": "Dunajska ulica",
                                "init": null
    
                            },
    
                            "HouseNumUnit": {
                                "required": false,
                                "editable": true,
                                "title": "Hišna številka",
                                "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                                "minlength": 1,
                                "maxlength": 10,
                                "example": "244",
                                "init": null
                            },
    
                            "HouseNumAddUnit": {
                                "required": false,
                                "editable": true,
                                "title": "Dodatek k hišni številki",
                                "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                                "minlength": 1,
                                "maxlength": 10,
                                "example": "B",
                                "init": null
                            },
    
                            "SettlementUnit": {
                                "required": false,
                                "editable": true,
                                "title": "Naselje",
                                "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                                "minlength": 1,
                                "maxlength": 100,
                                "example": "Ljubljana",
                                "init": null
                            },
    
                            "CityNameUnit": {
                                "required": false,
                                "editable": true,
                                "title": "Pošta",
                                "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                                "minlength": 1,
                                "maxlength": 40,
                                "example": "Ljubljana",
                                "init": null
                            },
    
                            "PostCodeUnit": {
                                "required": false,
                                "editable": true,
                                "title": "Poštna številka",
                                "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                                "minlength": 4,
                                "maxlength": 4,
                                "example": "1000",
                                "init": null
                            },
    
                            "BPMType": {
                                "required": false,
                                "editable": true,
                                "title": "Premični poslovni prostor",
                                "tooltip": "DA, če zavezanec izdaja račune v premičnem poslovnem prostoru. Možne izbire: A - premičen objekt (npr. prevozno sredstvo, premična stojnica) ali B – objekt na stalni lokaciji (npr. stojnica na tržnici, kiosk) ali C – posamezna elektronska naprava za izdajo računov ali vezana knjiga računov v primerih, ko zavezanec ne uporablja drugega poslovnega prostora",
                                "minlength": 1,
                                "maxlength": 1,
                                "example": null,
                                "init": null
                            },
    
                            "BPValidityDate": {
                                "required": true,
                                "editable": true,
                                "title": "Datum začetka veljavnosti podatkov",
                                "tooltip": "Datum začetka veljavnosti podatkov o poslovnem prostoru, ki se posredujejo.",
                                "minlength": null,
                                "maxlength": null,
                                "example": "2024-11-27",
                                "type" : "date",
                                "init": null
                            },
    
                            "BPSpecNotes": {
                                "required": true,
                                "editable": true,
                                "title": "Ostalo",
                                "tooltip": "Vpišejo se morebitne druge oznake, ki podrobneje pojasnjujejo zapise v zvezi z vsebino podatkov o poslovnem prostoru.",
                                "minlength": 1,
                                "maxlength": 1000,
                                "example": "Primer prijave poslovnega prostora",
                                "init": null
    
                            }
                },
                "execute" : {"method" : "Data.Create", "params" : {"entity" : "EU_Units", "values" : {"OrgId" : "<!--aorg.Id-->"}}, "button" : "Create Unit"}
            },
            {
                "type" : "extension",
                "execute" : {"method" : "EUeInvoices.RegisterBusinessPremise", "params" : {"UnitId" : "<!--workflow.wf1.response.values.0.id-->", "Mode" : "PROD"}, "button" : "Register unit"}
            }
        ],
        "workflows": [
            {"execute" : {"method" : "Data.Modify", "params" : {"entity" : "VP_DevicesOrgUnits", "filter":"Id='<!--device.Id-->'", "values" : {"FiscUnitRegCodeDef" : null, "OrgUnitId":"<!--value.Id-->"}}}}
        ]
    }
}

const bb =  {
    "type" : "connection", //input, connectionByKey, connectionById
    "required": false,
    "label" : "Unit registration code",
    "editable": true,
    "workflows" : { 
        "beforeSave" : {
            create : [{"execute" : {"method" : "Data.GetEntityData", "params" : {"entity" : "EU_UI_AdminTransfomer"}}}], 
            modify:[{"execute" : {"method" : "Data.GetEntityData", "params" : {"entity" : "EU_UI_AdminTransfomer"}}}], 
            delete:[{"execute" : {"method" : "Data.GetEntityData", "params" : {"entity" : "EU_UI_AdminTransfomer"}}}]}, 
        "afterSave" : {create : [], modify:[], delete:[]}},
    "workflow": [{"execute" : {"method" : "EUeInvoices.", "button" : "Register Unit or whatever", "params" : {"DeviceId" : "<!--device.Id-->", "Unit" : "<!--value-->"}}}],
    "instructions": "https://miniblagajna.fu.gov.si",
    "instructionsText": "Vpiše se oznaka poslovnega prostora, v katerem zavezanec izdaja račune pri gotovinskem poslovanju in je bila predhodno registrirana na davčnem portalu za potrebe fiskalizacije. Več na https://www.fu.gov.si/fileadmin/Internet/Nadzor/Podrocja/Davcne_blagajne_in_VKR/Opis/Davcne_blagajne_in_davcno_potrjevanje_racunov.docx"
}

const cc =  {
    "type" : "connection", //input, connectionByKey, connectionById
    "required": false,
    "label" : "Unit registration code",
    "editable": true,
    "workflows" : [{"execute" : {"method" : "Data.GetEntityData", "params" : {"entity" : "ConTables"},"button" : "Register Unit"}}],
    "workflow": [{"execute" : {"method" : "EUeInvoices.", "button" : "Register Unit or whatever", "params" : {"DeviceId" : "<!--device.Id-->", "Unit" : "<!--value-->"}}}],
    "instructions": "https://miniblagajna.fu.gov.si",
    "instructionsText": "Vpiše se oznaka poslovnega prostora, v katerem zavezanec izdaja račune pri gotovinskem poslovanju in je bila predhodno registrirana na davčnem portalu za potrebe fiskalizacije. Več na https://www.fu.gov.si/fileadmin/Internet/Nadzor/Podrocja/Davcne_blagajne_in_VKR/Opis/Davcne_blagajne_in_davcno_potrjevanje_racunov.docx"
}


const zz =  {
    "type" : "connection", //input, connectionByKey, connectionById
    "required": false,
    "label" : "Unit registration code",
    "editable": false,
    "workflows" : [
        {
            "fields" : {
                "FiscUnitRegCode": {
                        "required": true,
                        "editable": true,
                        "title": "Oznaka poslovnega prostora",
                        "tooltip": "Vpiše se oznaka poslovnega prostora, v katerem zavezanec izdaja račune pri gotovinskem poslovanju.Oznaka je lahko sestavljena iz številk in črk 0-9, a-z, A-Z.Oznaka mora biti enaka kot tista, ki je navedena na računih. Oznaka je enkratna na nivoju zavezanca.",
                        "minlength": 1,
                        "maxlength": 20,
                        "example": "LK1",
                        "default" : "<!--aorg.Id-->",
                        "init": null,
                        "value" : null      //this gets filled in by user and will reflect the data written on the form at the time of executeion
                    }
            },
            "execute" : {"method" : "Data.GetEntityData", "params" : {"entity" : "ConTables"},"button" : "Register Unit or whatever"}}
    ],
    "instructions": "https://miniblagajna.fu.gov.si",
    "instructionsText": "Vpiše se oznaka poslovnega prostora, v katerem zavezanec izdaja račune pri gotovinskem poslovanju in je bila predhodno registrirana na davčnem portalu za potrebe fiskalizacije. Več na https://www.fu.gov.si/fileadmin/Internet/Nadzor/Podrocja/Davcne_blagajne_in_VKR/Opis/Davcne_blagajne_in_davcno_potrjevanje_racunov.docx"
}

const yy =  {
    "type" : "connection", //input, connectionByKey, connectionById
    "required": false,
    "editable": false,
    "label" : "Unit registration code",
    "workflows" : [
        {
            "type" : "table",
            "name" : "wf1",
            "fields" : {
                "FiscUnitRegCode": {
                            "required": true,
                            "editable": true,
                            "title": "Oznaka poslovnega prostora",
                            "tooltip": "Vpiše se oznaka poslovnega prostora, v katerem zavezanec izdaja račune pri gotovinskem poslovanju.Oznaka je lahko sestavljena iz številk in črk 0-9, a-z, A-Z.Oznaka mora biti enaka kot tista, ki je navedena na računih. Oznaka je enkratna na nivoju zavezanca.",
                            "minlength": 1,
                            "maxlength": 20,
                            "example": "LK1",
                            "init": null
                        },
                        "BPImmovable": {
                            "required": false,
                            "editable": true,
                            "title": "Tip prostora",
                            "tooltip": "True, če zavezanec izdaja račune v premičnem poslovnem prostoru.",
                            "minlength": 1,
                            "maxlength": 1,
                            "example": true,
                            "init": null
                        },
                        "BPImCadastralNum": {
                            "required": false,
                            "editable": true,
                            "title": "Številka katastrske občine",
                            "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                            "minlength": 0,
                            "maxlength": 4,
                            "example": "1200",
                            "init": null
                        },
                        "BPImBuildNum": {
                            "required": false,
                            "editable": true,
                            "title": "Številka stavbe",
                            "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                            "minlength": 0,
                            "maxlength": 5,
                            "example": 12,
                            "init": null
                        },
                        "BPImBuildSecNum": {
                            "required": false,
                            "editable": true,
                            "title": "Številka dela stavbe",
                            "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                            "minlength": 0,
                            "maxlength": 4,
                            "example": 3,
                            "init": null
                        },

                        "AddressUnit": {
                            "required": false,
                            "editable": true,
                            "title": "Ulica",
                            "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                            "minlength": 1,
                            "maxlength": 100,
                            "example": "Dunajska ulica",
                            "init": null

                        },

                        "HouseNumUnit": {
                            "required": false,
                            "editable": true,
                            "title": "Hišna številka",
                            "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                            "minlength": 1,
                            "maxlength": 10,
                            "example": "244",
                            "init": null
                        },

                        "HouseNumAddUnit": {
                            "required": false,
                            "editable": true,
                            "title": "Dodatek k hišni številki",
                            "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                            "minlength": 1,
                            "maxlength": 10,
                            "example": "B",
                            "init": null
                        },

                        "SettlementUnit": {
                            "required": false,
                            "editable": true,
                            "title": "Naselje",
                            "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                            "minlength": 1,
                            "maxlength": 100,
                            "example": "Ljubljana",
                            "init": null
                        },

                        "CityNameUnit": {
                            "required": false,
                            "editable": true,
                            "title": "Pošta",
                            "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                            "minlength": 1,
                            "maxlength": 40,
                            "example": "Ljubljana",
                            "init": null
                        },

                        "PostCodeUnit": {
                            "required": false,
                            "editable": true,
                            "title": "Poštna številka",
                            "tooltip": "DA, če zavezanec izdaja račune v nepremičnem poslovnem prostoru.",
                            "minlength": 4,
                            "maxlength": 4,
                            "example": "1000",
                            "init": null
                        },

                        "BPMType": {
                            "required": false,
                            "editable": true,
                            "title": "Premični poslovni prostor",
                            "tooltip": "DA, če zavezanec izdaja račune v premičnem poslovnem prostoru. Možne izbire: A - premičen objekt (npr. prevozno sredstvo, premična stojnica) ali B – objekt na stalni lokaciji (npr. stojnica na tržnici, kiosk) ali C – posamezna elektronska naprava za izdajo računov ali vezana knjiga računov v primerih, ko zavezanec ne uporablja drugega poslovnega prostora",
                            "minlength": 1,
                            "maxlength": 1,
                            "example": null,
                            "init": null
                        },

                        "BPValidityDate": {
                            "required": true,
                            "editable": true,
                            "title": "Datum začetka veljavnosti podatkov",
                            "tooltip": "Datum začetka veljavnosti podatkov o poslovnem prostoru, ki se posredujejo.",
                            "minlength": null,
                            "maxlength": null,
                            "example": "2024-11-27",
                            "type" : "date",
                            "init": null
                        },

                        "BPSpecNotes": {
                            "required": true,
                            "editable": true,
                            "title": "Ostalo",
                            "tooltip": "Vpišejo se morebitne druge oznake, ki podrobneje pojasnjujejo zapise v zvezi z vsebino podatkov o poslovnem prostoru.",
                            "minlength": 1,
                            "maxlength": 1000,
                            "example": "Primer prijave poslovnega prostora",
                            "init": null

                        }
            },
            "execute" : {"method" : "Data.Create", "params" : {"entity" : "EU_Units", "values" : {"OrgId" : "<!--aorg.Id-->"}}}
        },{
            "type" : "table",
            "fields" : {
                "FiscUnitRegCode": {
                            "required": true,
                            "editable": true,
                            "title": "Oznaka poslovnega prostora",
                            "tooltip": "Vpiše se oznaka poslovnega prostora, v katerem zavezanec izdaja račune pri gotovinskem poslovanju.Oznaka je lahko sestavljena iz številk in črk 0-9, a-z, A-Z.Oznaka mora biti enaka kot tista, ki je navedena na računih. Oznaka je enkratna na nivoju zavezanca.",
                            "minlength": 1,
                            "maxlength": 20,
                            "example": "LK1",
                            "default" : "<!--aorg.Id-->",
                            "init": null,
                            "value" : null      //this gets filled in by user and will reflect the data written on the form at the time of executeion
                        }
            },
            "execute" : {"method" : "Data.Create", "params" : {"entity" : "EU_Units", "values" : {"OrgId" : "<!--aorg.Id-->", "HouseNumAddUnit" : "<!--workflow.wf1.response.values.0.id-->"}}, "button" : "Next"}
        }
    ],
    "instructions": "https://miniblagajna.fu.gov.si",
    "instructionsText": "Vpiše se oznaka poslovnega prostora, v katerem zavezanec izdaja račune pri gotovinskem poslovanju in je bila predhodno registrirana na davčnem portalu za potrebe fiskalizacije. Več na https://www.fu.gov.si/fileadmin/Internet/Nadzor/Podrocja/Davcne_blagajne_in_VKR/Opis/Davcne_blagajne_in_davcno_potrjevanje_racunov.docx"
}

const defaultForm={
    "FiscDeviceRegCode" : FiscDeviceRegCode,
    "FiscUnitRegCodeDef" : FiscUnitRegCodeDef,
    "FiscOperatorRegCodeDef": FiscOperatorRegCodeDef,
}